import {MediaStream} from 'models/webRTCTypes';

export class Stream extends MediaStream {
  get isAudioEnabled() {
    const audioTracks = this.getAudioTracks?.();
    if (audioTracks.length > 0) {
      const audioTrack = audioTracks[0];
      return audioTrack.enabled;
    }

    return false;
  }

  get isVideoEnabled() {
    const videoTracks = this.getVideoTracks?.();
    if (videoTracks.length > 0) {
      const videoTrack = videoTracks[0];
      return videoTrack.enabled;
    }

    return false;
  }

  switchAudio = () => {
    const audioTracks = this.getAudioTracks?.();
    if (audioTracks.length > 0) {
      const audioTrack = audioTracks[0];
      audioTrack.enabled = !audioTrack.enabled;
    }

    return this;
  };

  audioEnableChangeValue = (value: boolean) => {
    const audioTracks = this.getAudioTracks?.();
    if (audioTracks.length > 0) {
      const audioTrack = audioTracks[0];
      audioTrack.enabled = value;
    }

    return this;
  };

  videoEnableChangeValue = (value: boolean) => {
    const videoTracks = this.getVideoTracks?.();
    if (videoTracks.length > 0) {
      const videoTrack = videoTracks[0];
      videoTrack.enabled = value;
    }

    return this;
  };

  switchVideo = (): Stream => {
    const videoTracks = this.getVideoTracks?.();
    if (videoTracks.length > 0) {
      const videoTrack = videoTracks[0];
      videoTrack.enabled = !videoTrack.enabled;
    }

    return this;
  };
}
